var _circle, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNicIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 26,
    fill: "#EAF3FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.0396 18H13.5908C13.0274 18 12.5713 18.4535 12.5713 19.0136V33.2044C12.5713 33.7646 13.0274 34.218 13.5908 34.218H37.0128C37.5762 34.218 38.0323 33.7646 38.0323 33.2044V19.0136C38.0591 18.4535 37.603 18 37.0396 18ZM36.5835 32.7509H14.0469V19.4671H36.5835V32.7509Z",
    fill: "#2D91E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5538 23.6983H33.7984C34.144 23.6983 34.4205 23.3366 34.4205 22.8843C34.4205 22.4321 34.144 22.0703 33.7984 22.0703H27.5538C27.2082 22.0703 26.9316 22.4321 26.9316 22.8843C26.9316 23.3366 27.2082 23.6983 27.5538 23.6983Z",
    fill: "#2D91E9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5538 26.9542H33.7984C34.144 26.9542 34.4205 26.5924 34.4205 26.1402C34.4205 25.688 34.144 25.3262 33.7984 25.3262H27.5538C27.2082 25.3262 26.9316 25.688 26.9316 26.1402C26.9316 26.5924 27.2082 26.9542 27.5538 26.9542Z",
    fill: "#2D91E9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5538 30.2101H33.7984C34.144 30.2101 34.4205 29.8483 34.4205 29.396C34.4205 28.9438 34.144 28.582 33.7984 28.582H27.5538C27.2082 28.582 26.9316 28.9438 26.9316 29.396C26.9316 29.8483 27.2082 30.2101 27.5538 30.2101Z",
    fill: "#2D91E9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5617 30.9102H22.4447C23.1959 30.9102 23.7325 30.2166 23.5715 29.4964L23.1959 27.8159C23.0081 27.0424 22.4178 26.4555 21.6934 26.2421C21.5861 26.2155 21.4788 26.2155 21.3715 26.2688C20.9691 26.4555 20.513 26.5889 20.03 26.5889C19.5471 26.5889 19.091 26.4822 18.6886 26.2688C18.5812 26.2155 18.4739 26.2155 18.3666 26.2421C17.6154 26.4289 17.0251 27.0424 16.8642 27.8159L16.4886 29.4964C16.2739 30.2166 16.8373 30.9102 17.5617 30.9102Z",
    fill: "#2D91E9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0057 25.6832C21.2207 25.6832 22.2057 24.7039 22.2057 23.4959C22.2057 22.2879 21.2207 21.3086 20.0057 21.3086C18.7906 21.3086 17.8057 22.2879 17.8057 23.4959C17.8057 24.7039 18.7906 25.6832 20.0057 25.6832Z",
    fill: "#2D91E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNicIcon);
export default __webpack_public_path__ + "static/media/NICIcon.87b2c43af7fe994495572cb90034e2e6.svg";
export { ForwardRef as ReactComponent };